import {Vehicle, VehicleEntity} from "../../../model/vehicle";
import {contains} from "../../../util/util";
import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export type VehicleSelectorProps = {
  regionId?: string;
  companyId?: string;
  showDoNotUse?: boolean;
};

const getRegionIdParam = createParamSelector<VehicleSelectorProps | undefined, string | undefined>(params => params?.regionId);
const getCompanyIdParam = createParamSelector<VehicleSelectorProps | undefined, string | undefined>(params => params?.companyId);
const getShowDoNotUseParam = createParamSelector<VehicleSelectorProps | undefined, boolean | undefined>(params => params?.showDoNotUse);

export const vehiclesSelector = () => createSelector(
  [getUseQueryResultData<Vehicle[]>, getRegionIdParam, getCompanyIdParam, getShowDoNotUseParam],
  (data, regionId, companyId, showDoNotUse) => {
    return selectVehiclesAndTransform(
      data ?? [], {
        regionId: regionId,
        companyId: companyId,
        showDoNotUse: showDoNotUse
      }
    );
  }
);

export const vehicleSelector = () => createSelector(
  [getUseQueryResultData<Vehicle>],
  (data) => {
    return data ? transformVehicle(data) : undefined;
  }
);

export const selectVehicles = (values?: Vehicle[], selector?: VehicleSelectorProps): Vehicle[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    if (selector?.regionId) {
      if (!contains(v.regionList, id => id === selector.regionId)) {
        filterIn = false;
      }
    }

    if (selector?.companyId) {
      if (selector.companyId !== v.companyId) {
        filterIn = false;
      }
    }

    const showDoNotUse = selector?.showDoNotUse ?? false;
    if (filterIn && !showDoNotUse && v.doNotUse) {
      filterIn = false;
    }

    return filterIn;
  });
};

export const transformVehicle = (value: Vehicle): VehicleEntity => {
  return VehicleEntity.from(value)
}

export const selectVehiclesAndTransform = (values?: Vehicle[], selector?: VehicleSelectorProps): VehicleEntity[] => {
  const selected = selectVehicles(values, selector);
  return selected.map(transformVehicle);
};
